export default __webpack_public_path__ + "static/media/IMG_5391.be2ee8c6.PNG";